import { Message } from "@/shared/reader";

import { RenderingError } from "../RenderingError";

import styles from "./FormattedMessage.module.css";

interface FormattedMessageProps {
  error: Error | null;
  message: Message | null;
}

export function FormattedMessage({ error, message }: FormattedMessageProps) {
  if (error !== null) {
    return <RenderingError error={error} />;
  }

  if (message === null) {
    return <pre className={`ph-no-capture ${styles.message}`}>No message</pre>;
  }

  const stringified = JSON.stringify(
    message,
    (_, v: unknown): unknown => {
      if (typeof v === "bigint") {
        return v.toString();
      }
      if (ArrayBuffer.isView(v) || v instanceof ArrayBuffer) {
        const view = v instanceof ArrayBuffer ? new Uint8Array(v) : v;
        if (view.byteLength <= 512) {
          return Array.from(view as ArrayLike<number>);
        }
        const buf = new Uint8Array(view.buffer, view.byteOffset, view.byteLength);
        const preview = Array.from(buf.subarray(0, 8))
          .map((b) => b.toString(16).padStart(2, "0"))
          .join(" ");
        return `<${buf.byteLength} bytes: ${preview} ...>`;
      }
      return v;
    },
    2,
  );
  return <pre className={`ph-no-capture ${styles.message}`}>{stringified}</pre>;
}
